<template>
    <!-- 添加数据2 -->

    <a-modal title="新增组织" v-model:open="open" @ok="handleOk" class="modals">
        <div class="push-input">
            <a><span class="startColor">*</span>组织名称：</a>
            <a-input v-model:value="pushData.deptName" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>组织代码：</a>
            <a-input v-model:value="pushData.deptCode" maxlength="20" class="push-data" />
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>父级组织：</a>
            <a-select v-model:value="pushData.deptParent"  class="push-data">
                <a-select-option v-for="p in parent" :key="p.id" :value="p.id">{{p.deptName}}</a-select-option>
            </a-select>
        </div>
        <div class="push-input">
            <a><span class="startColor">*</span>组织排序：</a>
            <a-input v-model:value="pushData.deptSort" maxlength="2" type="number" class="push-data" />
        </div>
        <template #footer>
            <a-button key="back" @click="toAddCancel">返回</a-button>
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">提交</a-button>
        </template>
    </a-modal>
</template>
<script>
import { saveDepts,listParentDepts } from '@/api/service';
import { message } from 'ant-design-vue';
import { ref } from 'vue';
export default {
    name: 'addComponent',
    setup() {
        const loading = ref(false);//添加提交时的加载
        const pushData = ref({});//提交数据
        const open = ref(false);//是否打开
        const parent = ref([]);//父级菜单
        //关闭窗口
        const toAddCancel = () => {
            open.value = false;
        }
        //查询父级列表
        const parentList = async ()=>{
            const response = await listParentDepts();
            if (response.code === 200) {
                parent.value = response.data;
            }
        }
        //提交数据
        const handleOk = async () => {
            console.log(pushData.value);
            const response = await saveDepts(pushData.value);
            if (response.code === 200) {
                message.success('添加成功');
                open.value = false;
            } else {
                message.error('添加失败' + response.msg);
                return false;
            }
        }
        parentList();
        return {
            loading,
            open,
            pushData,
            listParentDepts,
            parent,
            parentList,
            toAddCancel,
            handleOk,
            ref
        };
    }
}
</script>
<style>
.push-input {
    margin-top: 20px;
    display: block;
}

.modals {
    width: 400px;
}

.push-data {
    width: 80%;
}
</style>